import { create } from 'zustand'

/** 工作台当前聚焦的论证章（1–6）；供生成注入与门控 */
type State = {
  activeChapterIndex: number | null
  setActiveChapterIndex: (n: number | null) => void
  /** 右侧「契约与门控」轨是否展开 */
  gateRailOpen: boolean
  setGateRailOpen: (open: boolean) => void
  toggleGateRail: () => void
}

export const useThesisWorkspaceStore = create<State>((set) => ({
  activeChapterIndex: 1,
  setActiveChapterIndex: (n) => set({ activeChapterIndex: n }),
  gateRailOpen: false,
  setGateRailOpen: (open) => set({ gateRailOpen: open }),
  toggleGateRail: () => set((s) => ({ gateRailOpen: !s.gateRailOpen })),
}))
